import { TOOlTIP_FIELDS } from 'static/tooltipFields';
import billing from 'assets/locations/billing.svg?react';
import hq from 'assets/locations/hq.svg?react';
import office from 'assets/locations/office.svg?react';
import shipping from 'assets/locations/shipping.svg?react';
import store from 'assets/locations/store.svg?react';
import warehouse from 'assets/locations/warehouse.svg?react';
import factory from 'assets/locations/factory.svg?react';

export const LOCATION_TYPE = [
    { value: 'Headquarters', displayName: 'Headquarters', icon: hq },
    { value: 'Billing', displayName: 'Billing', icon: billing },
    { value: 'Office', displayName: 'Office', icon: office },
    { value: 'Production Facility', displayName: 'Production Facility', icon: factory },
    { value: 'Retail location', displayName: 'Retail location', icon: store },
    { value: 'Shipping', displayName: 'Shipping', icon: shipping },
    { value: 'Warehouse', displayName: 'Warehouse', icon: warehouse },
];

export const LOCATION_COLUMNS = [
  {
    title: 'Type',
    fieldName: 'type',
    fieldPath: TOOlTIP_FIELDS.locationType.fieldPath,
  },
  {
    title: 'Main Address',
    fieldName: 'address',
    fieldPath: TOOlTIP_FIELDS.locationAddress.fieldPath,
  },
  {
    title: 'City',
    fieldName: 'city',
    fieldPath: TOOlTIP_FIELDS.locationCity.fieldPath,
  },
  {
    title: 'State',
    fieldName: 'state',
    fieldPath: TOOlTIP_FIELDS.locationState.fieldPath,
  },
  {
    title: 'Country',
    fieldName: 'country',
    fieldPath: TOOlTIP_FIELDS.locationCountry.fieldPath,
  },
  {
    title: 'Zip Code',
    fieldName: 'zipCode',
    fieldPath: TOOlTIP_FIELDS.locationZipCode.fieldPath,
  },
  {
    title: 'Phone Number',
    fieldName: 'phoneNumber',
    fieldPath: TOOlTIP_FIELDS.locationPhoneNumber.fieldPath,
  },
  {
    title: 'Email',
    fieldName: 'email',
    fieldPath: TOOlTIP_FIELDS.locationEmail.fieldPath,
  },
  {
    title: 'Location Name',
    fieldName: 'locationName',
    fieldPath: TOOlTIP_FIELDS.locationName.fieldPath,
  },
  {
    title: 'Location Description',
    fieldName: 'locationDescription',
    width: 180,
    fieldPath: TOOlTIP_FIELDS.locationDescription.fieldPath,
  },
];

export const LOCATION_COLUMNS_AG = [
  {
    dataType: 'string',
    headerName: 'Type',
    fieldName: 'Type',
    fieldNameCamelCase: 'type',
    allowFilter: true,
    allowSort: true,
    resizable: true,
    cellRenderer: (params) => {
      const type = params?.data?.type ?? [];
      const displayType = type?.join(', ');
      return <>{displayType}</>;
    },
  },
  {
    dataType: 'string',
    headerName: 'Main Address',
    fieldName: 'address',
    fieldNameCamelCase: 'address',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'City',
    fieldName: 'city',
    fieldNameCamelCase: 'city',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'State',
    fieldName: 'state',
    fieldNameCamelCase: 'state',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'Country',
    fieldName: 'country',
    fieldNameCamelCase: 'country',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'Zipcode',
    fieldName: 'zipCode',
    fieldNameCamelCase: 'zipCode',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'Phone Number',
    fieldName: 'phoneNumber',
    fieldNameCamelCase: 'phoneNumber',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'Email',
    fieldName: 'email',
    fieldNameCamelCase: 'email',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'Location Name',
    fieldName: 'locationName',
    fieldNameCamelCase: 'locationName',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'Location Description',
    fieldName: 'locationDescription',
    fieldNameCamelCase: 'locationDescription',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
];
